import mobilebanner from "./images/banner/2.jpg";
import screenbanner from "./images/banner/1.jpg";
import Altitide from "./images/trendingProjects/Gurgaon/M3MAltitude.jpg";
import Mansion from "./images/trendingProjects/Gurgaon/M3MMansion.jpg";
import OneDxp from "./images/trendingProjects/Gurgaon/SmartworldOneDXP.jpg";
import UrbanResort from "./images/trendingProjects/Gurgaon/UrbanResort.jpg";
import SignatureGlobal from "./images/trendingProjects/Gurgaon/SignatureGlobalTitanium.jpg";
import DLFArbour from "./images/trendingProjects/Gurgaon/DLFTheArbour.jpg";
import DLFANDHERI from "./images/trendingProjects/Mumbai/DLFANDHERI.jpg"
import Lodha_Divino from "./images/trendingProjects/Mumbai/Lodha_Divino.jpg"
import MahindraHappinest from "./images/trendingProjects/Mumbai/MahindraHappinest.jpg"
import Neolivalibag from "./images/trendingProjects/Mumbai/Neolivalibag.jpg"
import Aditya_Birla from "./images/trendingProjects/Pune/Aditya_Birla.jpg"
import GodrejEvergreen from "./images/trendingProjects/Pune/GodrejEvergreen.jpg"
import ShapoorjiVanaha from "./images/trendingProjects/Pune/ShapoorjiVanaha.jpg"
import Yeshwanthpur from "./images/trendingProjects/Bengaluru/Yeshwanthpur.jpg"


export const Bannerdata = {
  mobilebanner: mobilebanner,
  screenbanner: screenbanner,
};

export const dataSlider = [
  {
    location: {
      Gurugram: "Gurugram",
      Bangalore: "Bangalore",
      Pune: "Pune",
      Mumbai: "Mumbai",
    },
  },
  {
    mumbaiImage: [
      {
        image1: "asdasd",
        image2: "asdasd",
      },
    ],
  },
];

export const GurugramProjectData = {
  location: "Hot Properties in Gurugram",
  properties: [
    {
      title: "M3M Altitude",
      image: Altitide,
      address: "Sector 65",
      price: "On Request",
      bed: "4.5 BHK",
      size: "3755-4270 Sq.Ft",
      url: `/m3m-altitude`,
      alt: "M3M Altitude",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "M3M Mansion",
      image: Mansion,
      address: "Sector 113",
      price: "On Request",
      bed: "3.5 - 4.5 BHK",
      size: "2080-3000 Sq.Ft",

      url: `/m3m-mansion`,
      alt: "M3M Mansion",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    // {
    //   title: "DLF The Arbour",
    //   image: OneDxp,
    //   address: "Sector 113, Gurgaon",
    //   price: "On Request",
    //   bed: "1-3 BHK",
    //   size: "....",

    //   url: `/dlf-the-arbour`,
    //   alt: "DLF The Arbour",
    // },
    {
      title: "Whiteland Urban Resort",
      image: UrbanResort,
      address: "Sector 103",
      price: "On Request",
      bed: "1-3 BHK",
      size: "....",

      url: `/whiteland-urban-resort`,
      alt: "Whiteland Urban Resort",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "Signature Global Titanium",
      image: SignatureGlobal,
      address: "Sector 71",
      price: "On Request",
      bed: "3.5 - 4.5 BHK",
      size: "2780 - 3780 Sq.Ft",

      url: `/signature-global-titanium`,
      alt: "signature-global-titanium",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "DLF The Arbour",
      image: DLFArbour,
      address: " Sector 77",
      price: "On Request",
      bed: "1 - 3 BHK",
      size: ".... Sq.Ft",

      url: `/dlf-arbour`,
      alt: "dlf-arbour",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};

export const BangaloreProjectData = {
  location: "Hot Properties in Bengaluru",
  properties: [
    {
      title: "Godrej Yeshwanthpur",
      image: Yeshwanthpur,
      address: "Yeshwanthpur, West Bengaluru",
      price: "On Request",
      bed: "3 - 4 BHK",
      size: "2200 - 3000 Sq.Ft",
      url: `/godrej-yeswanthpur`,
      alt: "godrej-yashwantpur",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};

export const PuneProjectData = {
  location: "Hot Properties in Pune",
  properties: [
    {
      title: "Aditya Birla Estate",
      image: Aditya_Birla,
      address: "Wellesley Road Pune",
      price: "On Request",
      bed: "1 - 4 BHK",
      size: "675 - 2519Sq.Ft",
      url: `/aditya-birla-estate`,
      alt: "Aditya Birla",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "Shapoorji Pallonji Golfland ",
      image: ShapoorjiVanaha,
      address: "Bavdhan, Pune",
      price: "On Request",
      bed: "2, 3, 4 BHK",
      size: "739 - 2955 Sq.Ft",

      url: `/shapoorji-pallonji-golfland `,
      alt: "Shapoorji Pallonji Vanaha",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "Godrej Evergreen Square",
      image: GodrejEvergreen,
      address: "Phase 3, Hinjawadi",
      price: "On Request",
      bed: "1, 2, 3 BHK",
      size: "....",
      url: `/godrej-evergreen-square`,
      alt: "Godrej Evergreen Square",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};

export const MumbaiProjectData = {
  location: "Hot Properties in Mumbai",
  
  properties: [
    {
      title: "Lodha Divino",
      image: Lodha_Divino,
      address: "Matunga ",
      price: "On Request",
      bed: "2, 3 & 4 BHK",
      size: "858  - 1680 Sq.Ft",
      url: `/lodha-divino-matunga`,
      alt: "Lodha Divino",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
      
    },
    {
      title: "Mahindra Happinest Kalyan",
      image: MahindraHappinest,
      address: "Kalyan ",
      price: "On Request",
      bed: "1, 2 & 3 BHK",
      size: "394 - 932 Sq.Ft",

      url: `/mahindra-lifespaces-happinest`,
      alt: "Mahindra Lifespaces Happinest",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "DLF Andheri West ",
      image: DLFANDHERI,
      address: "Andheri West ",
      price: "On Request",
      bed: "3 - 4 BHK",
      size: "1125 - 1955 Sq.Ft ",

      url: `/dlf-andheri-west`,
      alt: "DLF Andheri West",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "Neo Liv Alibaug",
      image: Neolivalibag,
      address: "Alibaug",
      price: "On Request",
      bed: "I - III Villa",
      size: "2200 - 3200 Sq.Ft ",

      url: `/neo-liv-alibaug`,
      alt: "neo-liv-alibaug",
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
